import React, { useState } from "react";
import { exportBracketPdf } from "../../utils/exportPdf";

// Button that exports the referenced bracket "stage" element as a PDF.
function ExportPdfButton({ targetRef, filename, className = "tn-ghost" }) {
  const [busy, setBusy] = useState(false);

  async function handleExport() {
    if (busy || !targetRef?.current) return;
    setBusy(true);
    try {
      await exportBracketPdf(targetRef.current, filename);
    } catch (e) {
      // Surface failures without crashing the view.
      // eslint-disable-next-line no-alert
      alert("Sorry, the PDF export failed. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      className={className}
      onClick={handleExport}
      disabled={busy}
      title="Download this bracket as a PDF"
    >
      {busy ? "Exporting…" : "⤓ PDF"}
    </button>
  );
}

export default ExportPdfButton;
